export class LocalStorageUtil {
    static loadData<T>(key: string, defaultValue?: T, jsonParser?:(obj:T)=>T): T {
        try {
           const data = localStorage.getItem(key);
            if (data) {
                let object = JSON.parse(data);
                if (jsonParser) {
                    object = jsonParser(object);
                }
                return object;
            }
        } catch (e) {
            console.log(e);
        }
        return defaultValue || null;
    }
    static saveData<T>(key: string, data: T): boolean {
        try {
            const json = JSON.stringify(data);
            localStorage.setItem(key, json);
            return true;
        } catch (e) {
            return false;
        }
    }

    static remove(key: string) {
        localStorage.removeItem(key);
    }
}